var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coning"},[_c('div',{staticClass:"coning-box"},[_c('img',{attrs:{"src":require("@/assets/1.png")}}),_vm._v(" "),_c('p',[_vm._v("页面正在建设中")]),_vm._v(" "),_c('router-link',{attrs:{"to":{path:'/home'}}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f6e2496","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coning.vue
// module id = null
// module chunks = 